import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import actionBarReducer from './actionBar';
import authReducer from './auth';
import billingNotificationReducer from './billingRedirect/billingRedirect';
import businessLibraryReducers from './businessLibrary';
import buttonReducer from './button/index';
import calendarReducer from './calendar';
import capitalReducers from './capital';
import confirmActionReducer from './confirm-action';
import confirmEmployeeReducer from './confirmEmployee/index';
import customerReducer from './customers';
import dashboardIndexReducer from './dashboard/index';
import employeeReducer from './employees';
import featureFlagsReducer from './featureFlags';
import featureRestrictionsReducer from './featureRestrictions';
import freshReducers from './fresh';
import ftue from './ftue';
import ingredientReducer from './ingredients';
import inventoryReducer from './inventory';
import kybReducers from './kyb';
import libraryReducers from './library';
import loadingSpinnerReducer from './loadingSpinner/index';
import moka from './moka';
import notificationReducer from './notifications';
import openPlatformReducer from './openPlatform';
import outletPageReducer from './outletPages';
import outletReducer from './outlet';
import paymentConfiguration from './paymentConfiguration';
import registerReducers from './register';
import reportsReducer from './reports';
import settingReducer from './setting';
import subscriptionExpiredReducer from './subscriptionExpired/index';
import tableManagementReducer from './tableManagement';
import uploadersReducer from './uploaders/index';
import uploadImageReducer from './uploadImage/index';
import userPropertiesReducer from './userProperties';
import inventoryFeatures from './inventoryFeatures';
import onlineStoreReducer from './onlineStore';

const reducer = combineReducers({
  actionBar: actionBarReducer,
  auth: authReducer, // auth specific reducer
  billingNotification: billingNotificationReducer,
  buttons: buttonReducer,
  businessLibrary: businessLibraryReducers,
  calendar: calendarReducer, // for dropdown calendar
  capital: capitalReducers,
  confirmAction: confirmActionReducer,
  confirmEmployee: confirmEmployeeReducer,
  customers: customerReducer,
  dashboard: combineReducers({ index: dashboardIndexReducer }),
  employee: employeeReducer,
  featureFlags: featureFlagsReducer,
  featureRestrictions: featureRestrictionsReducer,
  form: formReducer, // redux form reducer. Please don't change the key name
  fresh: freshReducers,
  ftue,
  ingredients: ingredientReducer,
  inventory: inventoryReducer,
  inventoryFeatures,
  kybForm: kybReducers,
  library: libraryReducers,
  loadingSpinner: loadingSpinnerReducer,
  moka, // moka default reducer. Please don't change the key name,
  notification: notificationReducer, // our custom reducer for notification.
  openPlatform: openPlatformReducer,
  outlet: outletReducer, // outlet for related user
  outletPages: outletPageReducer,
  paymentConfiguration,
  registerForm: registerReducers,
  reports: reportsReducer,
  routing: routerReducer, // reducer from react-router-redux. Please don't change the key name
  setting: settingReducer,
  subscriptionExpired: subscriptionExpiredReducer,
  tableManagement: tableManagementReducer,
  uploaders: combineReducers({
    import: uploadersReducer,
  }),
  uploadImage: combineReducers({ uploadImage: uploadImageReducer }),
  userProperties: userPropertiesReducer,
  onlineStore: onlineStoreReducer,
});

export default reducer;
